/**
 * Created by caiosilva on 29/11/15.
 */
let notifyId = 0;
const notifyTime = 4000;

function notification({ status = 'info', message = 'Notification' }) {
    // Define o tipo e o ícone com base no status
    const notificationTypes = {
        success: { type: 'positive', icon: 'check' },
        warning: { type: 'warning', icon: 'warning circle' },
        danger: { type: 'negative', icon: 'warning sign' },
        info: { type: 'info', icon: 'info circle' },
    };

    // Obter as configurações do tipo ou usar padrão
    let { type, icon } = notificationTypes[status] || notificationTypes.info;

    // Sobrescrevendo para 'black' sem retirar funcionalidades
    type = 'black';

    // Configurações para mostrar ícone e botão de fechar
    const hasIcon = false;
    const hasCloseButton = false;

    // Incrementa o ID da notificação
    notifyId++;

    // Gera o HTML da notificação, incluindo a barra de progresso
    const html = `
        <div id="notify-${notifyId}" class="ui ${type} message icon">
            ${hasIcon ? `<i class="${icon} icon"></i>` : ''}
            <div class="content">
                <p>${message}</p>
            </div>
            ${hasCloseButton ? '<i class="close icon"></i>' : ''}
            <div class="progress-bar" id="progress-${notifyId}"></div>
        </div>
    `;

    // Adiciona a notificação ao contêiner
    $('#notification-message').append(html);
    $(`#notify-${notifyId}`).transition('fly down in');

    // Inicia a animação da barra de progresso
    animateProgressBar(notifyId, notifyTime);

    // Define o auto-fechamento da notificação
    autoCloseMessage(notifyId, notifyTime);
}

function animateProgressBar(msgId, duration) {
    $(`#progress-${msgId}`).css({
        transition: `width ${duration}ms linear`,
        width: '0%'
    });
}

function autoCloseMessage(msgId, duration) {
    window.setTimeout(() => {
        $(`#notify-${msgId}`).transition('fly down out', () => {
            $(`#notify-${msgId}`).remove(); // Remove o elemento após a transição
        });
    }, duration);
}

// Evento para fechar a notificação manualmente
$(document).on('click', '.close', function () {
    $(this).closest('.message').transition('fly down out', function () {
        $(this).remove(); // Remove o elemento após a transição
    });
});

// Evento para fechar a notificação ao clicar nela
$(document).on('click', '[id^=notify-]', function () {
    $(this).transition('fly down out', function () {
        $(this).remove(); // Remove o elemento após a transição
    });
});